import ResourceServices from '@/services/ResourceServices'

export default {
  namespaced: true,
  state: () => ({
    codeResourceServiceGet200: 'RESOURCE-GET-200',
    msgResourceServiceError: 'No se pudo encontrar el recurso solicitado.'
  }),
  actions: {
    async noticeOfPrivacy() {
      const service = new ResourceServices()
      return service.noticeOfPrivacy()
    },
    async termsAndConditions() {
      const service = new ResourceServices()
      return service.termsAndConditions()
    }
  },
  getters: {
    codeResourceServiceGet200(state) {
      return state.codeResourceServiceGet200
    },
    msgResourceServiceError(state) {
      return state.msgResourceServiceError
    }
  }
}
